module.exports = __webpack_public_path__ + "img/鸡蛋花.f5738d84.jpg";